import React, { useEffect } from 'react';
import { setProductListingType } from '../../Actions/ProductListing.action';
import Icon from '../Icon';
import { ProductListingType } from '../../Reducers/ProductListing.reducer';
import clsx from 'clsx';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import { useTypedDispatch } from '../../Hooks/useTypedDispatch';
import useIsStoreScreen from '../../Hooks/useIsStoreScreen';
const CategoryLayoutSelect = () => {
  const { productListingType, showMasonryButton } = useTypedSelector(
    (state) => state.productListing
  );
  const dispatch = useTypedDispatch();

  const onListingTypeSelected = (listingType: ProductListingType) => {
    dispatch(setProductListingType(listingType));
  };
  const { current: userInfo } = useTypedSelector(
    (state) => state.userInfo
  );
  const isStoreScreen = useIsStoreScreen();
  const isB2b = userInfo?.isBusinessCustomer;

  const showDetailedListButton = isB2b && !isStoreScreen;

  return (
    <div className="flex md-down:-mr-2">
      {showDetailedListButton && (
        <button
          className="cursor-pointer p-2"
          onClick={() =>
            onListingTypeSelected(ProductListingType.DetailedList)
          }
        >
          <Icon
            name={
              productListingType == ProductListingType.DetailedList
                ? 'detailedlist-filled'
                : 'detailedlist-unfilled'
            }
            className="block h-5 w-5 "
          />
        </button>
      )}
      {showMasonryButton && (
        <button
          className="-rotate-90 cursor-pointer p-2 lg:rotate-0"
          onClick={() =>
            onListingTypeSelected(ProductListingType.Grid1plus2)
          }
        >
          <Icon
            name={
              productListingType == ProductListingType.Grid1plus2
                ? '2plus1grid-filled'
                : '2plus1grid'
            }
            className="block h-5 w-5 "
          />
        </button>
      )}
      <button
        className="cursor-pointer p-2"
        onClick={() => onListingTypeSelected(ProductListingType.Grid2by2)}
      >
        <Icon
          name={
            productListingType == ProductListingType.Grid2by2
              ? '2by2grid-filled'
              : '2by2grid'
          }
          className="block h-5 w-5 "
        />
      </button>
      <button
        className="cursor-pointer p-2"
        onClick={() => onListingTypeSelected(ProductListingType.Grid3by3)}
      >
        <Icon
          name={
            productListingType == ProductListingType.Grid3by3
              ? '3by3grid-filled'
              : '3by3grid'
          }
          className={clsx(
            'hidden h-5 w-5 md:block',
            productListingType == ProductListingType.Grid3by3
              ? 'text-black'
              : 'text-gray-500'
          )}
        />
        <Icon
          name={
            productListingType == ProductListingType.Grid3by3
              ? '1by1grid-filled'
              : '1by1grid'
          }
          className={clsx(
            'block h-5 w-5 md:hidden',
            productListingType == ProductListingType.Grid3by3
              ? 'text-black'
              : 'text-gray-500'
          )}
        />
      </button>
      {/* ---- TODO REMOVE THIS WHEN FIXED SETPRODUCTLISTINGTYPE LATER --- */}
      {/* <Icon
        name="grid-view"
        className={clsx(
          'grid-icon h-[1.5rem] w-[1.5rem] cursor-pointer',
          productListingType == ProductListingType.Grid
            ? 'text-black'
            : 'text-gray-500'
        )}
        onClick={() =>
          dispatch(setProductListingType(ProductListingType.Grid))
        }
      /> */}

      {/* <Icon
        name="view-agenda"
        className={clsx(
          'grid-icon  h-[1.5rem] w-[1.5rem] cursor-pointer',
          productListingType == ProductListingType.List
            ? 'text-black'
            : 'text-gray-500'
        )}
        onClick={() =>
          dispatch(setProductListingType(ProductListingType.List))
        }
      />
      <Icon
        name="square"
        className={clsx(
          'grid-icon  h-[1.5rem] w-[1.5rem] cursor-pointer',
          productListingType == ProductListingType.Grid
            ? 'text-black'
            : 'text-gray-500'
        )}
        onClick={() =>
          dispatch(
            setProductListingType(ProductListingType.SingleCard)
          )
        }
      /> */}
    </div>
  );
};

export default CategoryLayoutSelect;
